<template>
  <v-container fluid>
    <v-row dense>
      <v-col cols="4">
        <h2>Cambio de Contraseña</h2>
        <UpdatePasswordUserForm :model="password" :on-success="savePassword" :on-cancel="cancel"/>
      </v-col>
      <v-col cols="6" offset="2">
        <h2>Cambio de Informacion</h2>
        <MainGeneralForm :form="get_UserProfileForm" :model="MainObject" :on-success="saveForm" :on-cancel="cancelInfo" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import UpdatePasswordUserForm from '@/components/forms/UpdatePasswordUserForm'
import MainGeneralForm from '@/components/forms/main/MainGeneralForm'
export default {
  data: () => ({
    user: {},
    password: {},
    MainObject: {},
    typeForm: ''
  }),
  components: {
    UpdatePasswordUserForm,
    MainGeneralForm
  },
  mounted () {
    this.user = this.$cookies.get('user')
    this.MainObject = this.user
  },
  methods: {
    ...mapActions(['PostObject']),
    savePassword (model) {
      this.typeForm = 'change-password'
      model.id = this.user.id
      const router = '/auth/login/change-password'
      // console.log('model', model)
      this.PostObject({ url: router, data: model })
    },
    cancel () {
      this.password = {}
    },
    saveForm (model) {
      this.typeForm = 'change-info'
      const router = '/auth/user/change-information'
      this.PostObject({ url: router, data: model })
    },
    cancelInfo () {
      this.MainObject = {}
    },
    ...mapMutations([])
  },
  computed: {
    ...mapGetters(['get_object', 'get_UserProfileForm'])
  },
  watch: {
    get_object (val) {
      if (this.typeForm === 'change-password') {
        this.$swal({
          type: 'success',
          icon: 'success',
          title: 'Exitoso !',
          text: 'Contraseña actualizado.'
        })
        this.typeForm = ''
      } else if (this.typeForm === 'change-info') {
        this.$swal({
          type: 'success',
          icon: 'success',
          title: 'Exitoso !',
          text: 'Informacion de la cuenta actualizado.'
        })
        const user = { id: val.id, email: val.correo, nombre: val.nombre, usuario: val.usuario }
        this.$cookies.set('user', user)
        this.typeForm = ''
      }
    }
  }
}
</script>
